import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    submenu_paper: {
      marginLeft: theme.spacing(0.5),
    },
  }),
  { name: 'ItemLocked' }
);
